import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../firebase/config";

export async function logUsageEvent({ type, name, meta = {}, classId = "" }) {
  try {
    const user = auth.currentUser;
    if (!user) {
      return;
    }
    await addDoc(collection(db, "analyticsEvents"), {
      type,
      name,
      classId,
      meta,
      userId: user.uid,
      createdAt: serverTimestamp(),
    });
  } catch (err) {
    console.error("Usage analytics failed", err);
  }
}
